var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t.__(
          "listing.batchComponents.AddRecurringTermComponent.add_deadlines"
        ),
        visible: true,
        width: "420",
        "before-close": _vm.close
      }
    },
    [
      _c("label", { attrs: { for: "recAmount" } }, [
        _vm._v(
          _vm._s(
            _vm.$l10n.__("Nombre d'échéances à rajouter sur chaque abonnement")
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "el-select",
        {
          staticClass: "wp-10 mt-2 mb-4",
          attrs: { id: "recAmount", filterable: "", name: "amount" },
          model: {
            value: _vm.amount,
            callback: function($$v) {
              _vm.amount = $$v
            },
            expression: "amount"
          }
        },
        _vm._l(20, function(i) {
          return _c("el-option", { key: i, attrs: { label: i, value: i } })
        }),
        1
      ),
      _vm._v(" "),
      _c("CompassAlert", {
        staticClass: "mb-0",
        attrs: {
          description: _vm.$t.__(
            "listing.batchComponents.AddRecurringTermComponent.only_in_progress_subscriptions_will_be_modified"
          ),
          showClose: false,
          type: "warning"
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.confirm"),
              type: "primary",
              disabled: this.amount <= 0
            },
            on: { click: _vm.save }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }